var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAcceptanceExpertIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    fill: "none",
    viewBox: "0 0 10 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.5 10.5v-.736a1.5 1.5 0 0 1 1.206-1.47l1.423-.285c.117-.024.24 0 .34.067l.006.004a2.75 2.75 0 0 0 3.05 0l.007-.004c.1-.067.222-.09.34-.067l1.422.284A1.5 1.5 0 0 1 9.5 9.764v.736M3 10V8.035M7 10V8.035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4h4a.5.5 0 0 0 .5-.5V3A2.5 2.5 0 0 0 5 .5v0A2.5 2.5 0 0 0 2.5 3v.5A.5.5 0 0 0 3 4Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 4h5.5M7 4v1a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2V4M6.05 6.703l.362 1.448M3.95 6.703 3.59 8.15M4.125 4v-.875c0-.483.392-.875.875-.875v0c.483 0 .875.392.875.875V4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAcceptanceExpertIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AcceptanceExpertIcon.659ad9d9.svg";
export { ForwardRef as ReactComponent };